


























import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ExerciseSelection extends Vue {
  private exercises: string[];

  public constructor() {
    super();
    this.exercises = this.$store.getters.settings.exercises;
  }

  private setExercise(exercise: string) {
    this.$store.dispatch('setExercise', exercise)
    .then( () => {
        this.$router.push('devices');
    });
  }

}
